import { render, staticRenderFns } from "./EstablishmentsIntegrationManagerModal.vue?vue&type=template&id=704c3dea&scoped=true"
import script from "./EstablishmentsIntegrationManagerModal.vue?vue&type=script&lang=js"
export * from "./EstablishmentsIntegrationManagerModal.vue?vue&type=script&lang=js"
import style0 from "./EstablishmentsIntegrationManagerModal.vue?vue&type=style&index=0&id=704c3dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704c3dea",
  null
  
)

export default component.exports